import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icons } from '../../helpers/icons'

import PuffLoader from 'react-spinners/PuffLoader'
import Card from '../Card/Card'
import placeholder from '../../assets/images/cacti-club-placeholder.jpg'

interface Props {
  nfts: Array<any>
  isViewingCollection: boolean
  isLoading: boolean
  hasMinted: boolean
  startingIndex: number
}

function NFTShowcase(props: Props) {
  const [swiper, setSwiper]: any = useState<Swiper>()

  return (
    <>
      <div className="banner-main-top">
        <h2>
          {!props.hasMinted
            ? 'Your collection'
            : props.nfts.length === 1 && props.hasMinted
              ? `Congratulations, you minted ${props.nfts.length} Cacti!`
              : `Congratulations, you minted ${props.nfts.length} Cacti's!`
          }
        </h2>
        <p>
          {props.startingIndex <= 0 && !props.isViewingCollection && props.nfts.length > 0 ?
            "Cacti's haven't been revealed yet, we'll be anytime soon!"
            : !props.isLoading && props.nfts.length > 0
              ? 'An eclectic collection of 9999 randomly-generated, use case-oriented 3D NFTs spiking up on the Binance blockchain.'
              : !props.isLoading && props.nfts.length <= 0 ? "You haven't added any Cacti's to your collection yet!"
                : "Collecting your Cacti's..."
          }
        </p>
      </div>
      <div className={`slider-wrap ${props.isLoading ? 'is-loading' : ''}`}>
        {props.nfts.length > 1 && (
          <div className="previous" onClick={() => swiper.slidePrev()}>
            <FontAwesomeIcon icon={icons.chevronLeft} />
          </div>
        )}
        {props.isLoading ? (
          <PuffLoader />
        ) : (
          <>
            {props.nfts.length > 0 && (
              <Swiper
                onSwiper={(swiper: any) => setSwiper(swiper)}
                slidesPerView={1}>
                {props.nfts.map((nft: any, key: number) => {
                  return (
                    <React.Fragment key={parseInt(nft.tokenID) + key + Math.random()}>
                      <SwiperSlide key={parseInt(nft.tokenID) + key + Math.random() + 'slide'}>
                        <Card nft={props.startingIndex <= 0 ? { image: placeholder } : nft} />
                        <div className='card-attribute-container'>
                          {nft && nft.attributes && nft.attributes.map(((attr: any) => {
                            return <><span>{attr.trait_type}</span>: {attr.value} {attr.trait_type === 'Head' ? '' : <>&nbsp;//&nbsp;</>} </>
                          }))}
                        </div>
                      </SwiperSlide>
                    </React.Fragment>
                  )
                })}
              </Swiper>
            )}
            {props.nfts.length <= 0 && (
              <Swiper
                onSwiper={(swiper: any) => setSwiper(swiper)}
                slidesPerView={1}>
                <SwiperSlide>
                  <Card nft={{ image: placeholder }} />
                </SwiperSlide>
              </Swiper>
            )}
          </>
        )}
        {props.nfts.length > 1 && (
          <div className="next" onClick={() => swiper.slideNext()}>
            <FontAwesomeIcon icon={icons.chevronRight} />
          </div>
        )}
      </div>
    </>
  )
}

export default NFTShowcase
